export default __webpack_public_path__ + "static/media/BandSawImg.a463f1c8.jpg";